
import React from "react";
import "../Navbar.css"; // move CSS into this file
import { Link } from 'react-router-dom';

import {
  FaCode,
  FaFileCode,
  FaCodeBranch,
  FaWandMagicSparkles,
  FaFileArrowDown,
  FaWandMagic,
  FaCodeCompare,
  FaJava,
  FaPython,
  FaG,
} from "react-icons/fa6";

import { SiGo } from "react-icons/si";

import { FaPhp } from "react-icons/fa";
import { PiFileCSharp, PiFileCppDuotone, PiFileCDuotone } from "react-icons/pi";


const Navbar = () => {
  return (
    <nav className="navbar">
      {/* Logo Section */}
        <div className="logo">
          <Link to="/" className="logo-link">
            <span className="logo-text">JC }</span>
          </Link>
        </div>

      {/* JSON */}
      <div className="menu-section">
        <h3>
          <FaCode /> JSON
        </h3>
        <div className="links">
          <a href="/json-formatter">
            <FaWandMagicSparkles /> Formatter
          </a>
		  <a href="/json-to-xml">
            <FaFileArrowDown /> To Xml
          </a>
		  <a href="/json-to-yaml">
            <FaFileArrowDown /> To Yaml
          </a>
		   <a href="/json-to-csv">
            <FaFileArrowDown /> To Csv
          </a>
		   <a href="/csv-to-json">
            <FaFileArrowDown /> From Csv
          </a>
        </div>
      </div>

      {/* Code */}
      <div className="menu-section">
        <h3>
          <FaCodeBranch /> Code
        </h3>
        <div className="links">
          <a href="/json-to-java">
            <FaJava /> Java
          </a>
          <a href="/json-to-php">
            <FaPhp /> PHP
          </a>
          <a href="/json-to-c">
            <PiFileCDuotone /> C
          </a>
          <a href="/json-to-cpp">
            <PiFileCppDuotone /> C++
          </a>
          <a href="/json-to-csharp">
            <PiFileCSharp /> C#
          </a>
          <a href="/json-to-python">
            <FaPython /> Python
          </a>
		  <a href="/json-to-go">
            <SiGo /> Go
          </a>
        </div>
      </div>

      {/* XML */}
      <div className="menu-section">
        <h3>
          <FaFileCode /> XML
        </h3>
        <div className="links">
          <a href="/xml-formatter">
            <FaWandMagic /> Formatter
          </a>
          <a href="/xml-to-json">
            <FaCodeCompare /> To JSON
          </a>
        </div>
      </div>

      {/* YAML */}
      <div className="menu-section">
        <h3>
          <FaFileCode /> YAML
        </h3>
        <div className="links">
          <a href="/yaml-formatter">
            <FaWandMagic /> Formatter
          </a>
          <a href="/yaml-to-json">
            <FaCodeCompare /> To JSON
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
